<mat-card-content class="w-100-p mb-0">
    <div class="p-24 stats-wrapper">
        <div class="chart-wrapper w-100-p" fxLayoutAlign="space-between center" *ngIf="horizontalView; else verticalView">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="chart-title-wrapper w-100-p">
                <div fxLayout="row">
                    <div
                        fxLayoutAlign="center center"
                        class="icon-wrapper mr-8"
                        [ngStyle]="{
                            background: '#D5E1A4',
                            fill: '#95AF3F'
                        }"
                    >
                        <mat-icon svgIcon="dashboard_avg_learning_time"></mat-icon>
                    </div>
                    <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0">
                        {{ 'TENANT_DASHBOARD.CHART.total_learning_time' | translate }}
                        <span
                            class="ml-8 info-icon"
                            fxLayoutAlign="center center"
                            matTooltip="{{ 'TENANT_DASHBOARD.CHART.TOOLTIP.total_learnging_time' | translate }}"
                            matTooltipPosition="above"
                            tabindex="0"
                        >
                            i
                        </span>
                    </label>
                </div>
            </div>
            <div fxLayout="row" class="horizontal text-nowrap">
                <span>{{ totalLearningTime | msToHumanizeTimePipe }}</span>
            </div>
        </div>

        <ng-template #verticalView>
            <div fxLayout="column" class="chart-wrapper w-100-p">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="chart-title-wrapper mb-12 w-100-p">
                    <div fxLayout="row">
                        <div
                            fxLayoutAlign="center center"
                            class="icon-wrapper mr-8"
                            [ngStyle]="{
                                background: '#D5E1A4',
                                fill: '#95AF3F'
                            }"
                        >
                            <mat-icon svgIcon="dashboard_avg_learning_time"></mat-icon>
                        </div>
                        <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0">
                            {{ 'TENANT_DASHBOARD.CHART.total_learning_time' | translate }}
                            <span
                                class="ml-8 info-icon"
                                fxLayoutAlign="center center"
                                matTooltip="{{ 'TENANT_DASHBOARD.CHART.TOOLTIP.total_learnging_time' | translate }}"
                                matTooltipPosition="above"
                                tabindex="0"
                            >
                                i
                            </span>
                        </label>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 auto" class="bg-zinc-50 min-w-2">
                    <span fxLayout="row" fxLayoutAlign="center center" class="text-xs leading-5 text-gray-600 max-w-1 text-center tracking-widest uppercase">
                        {{ totalLearningTime | msToHumanizeTimePipe }}
                    </span>
                </div>
            </div>
        </ng-template>
    </div>
</mat-card-content>
